/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Region } from '../../models/region';

export interface GetRegion$Params {
  id: string;
}

export function getRegion(http: HttpClient, rootUrl: string, params: GetRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
  const rb = new RequestBuilder(rootUrl, getRegion.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Region>;
    })
  );
}

getRegion.PATH = '/region/{id}';
